import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Kit de Comunicación de Bolsillo',
  desc: '50 fichas mini para el llavero. La voz de tu hijo que viaja a todos lados.'
}, {
  title: 'Guía de Primeros Auxilios Sensoriales',
  desc: '10 técnicas para calmar el sistema nervioso en los primeros 5 minutos de escalada.'
}, {
  title: 'Recetario TEA: Texturas y Transiciones',
  desc: '10 recetas para ampliar la dieta en niños con selectividad alimentaria, sin peleas.'
}, {
  title: 'Manual de Adaptación Escolar Sin Palabras',
  desc: 'Guía lista para la maestra: perfil sensorial, pictogramas en el aula y protocolo de crisis.'
}, {
  title: 'Planner de Logros y Seguimiento TEA',
  desc: 'Registro de victorias, sueño y alimentación, con informe mensual para el terapeuta.'
}];
export function BonusesSection() {
  return <section className="py-12 md:py-16 bg-stone-50" data-id="element-17">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-2xl font-bold text-teal-900 mb-2" data-id="element-20">
            🎁 LOS 5 BONOS EXCLUSIVOS
          </h2>
          <p className="text-stone-600" data-id="element-21">
            Siempre incluidos. Cinco herramientas prácticas, listas para usar.
            Sin relleno.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-22">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-6 border border-stone-200 shadow-sm relative flex flex-col" data-id="element-23">
              <div className="text-xs font-bold text-stone-400 mb-1" data-id="element-24">
                Bono {i + 1}
              </div>
              <div className="flex items-center gap-2 mb-3" data-id="element-25">
                <span className="text-sm text-stone-400 line-through" data-id="element-26">
                  $3.000
                </span>
                <span className="bg-teal-100 text-teal-700 text-xs font-bold px-2 py-0.5 rounded" data-id="element-27">
                  GRATIS
                </span>
              </div>
              <h3 className="font-bold text-teal-900 mb-2 leading-tight" data-id="element-28">
                {b.title}
              </h3>
              <p className="text-sm text-stone-600 flex-grow" data-id="element-29">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center text-sm font-medium text-stone-600" data-id="element-30">
          Valor total de los 5 Bonos:{' '}
          <span className="line-through" data-id="element-31">$15.000</span> →{' '}
          <span className="text-teal-600 font-bold" data-id="element-32">
            GRATIS en las dos opciones
          </span>
        </div>
      </div>
    </section>;
}